var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-card',{staticClass:"item"},[_c('el-button',{staticClass:"item--empty",on:{"click":function($event){_vm.$router.push("submission")}}},[_c('i',{staticClass:"el-icon-plus",staticStyle:{"font-size":"3em"}}),_vm._v(" "),_c('p',[_vm._v("Add a new film")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4e9a896","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/ListItemAddButton.vue
// module id = 752
// module chunks = 10